import { useState } from "react";
import { useSidebar } from "./useSidebar";
import styles from "./Sidebar.module.css";
import theme from "../../themes/ThemeLoader";
import HamburgerIcon from "../../assets/hamburger.svg";
import BackIcon from "../../assets/back.svg";

const Sidebar = () => {
  const [expanded, setExpanded] = useState(false);
  const {
    topItems,
    bottomItems,
    getRoute,
    getLabel,
    handleNavigation
  } = useSidebar();

  const VERSION_NAME = theme.versionName;
  const toggleSidebar = () => {
    setExpanded(!expanded);
  };

  const handleItemClick = (item, route) => {
    if (item.externalUrl) {
      window.open(item.externalUrl, "_blank", "noopener,noreferrer");
      return;
    }
    handleNavigation(route);
  };
  const renderLabel = (label) => {
  if (Array.isArray(label)) {
    return (
      <div className={styles.containerTextLarge}>
        {label.map((text, index) => (
          <span key={index} className={styles.text}>
            {text}
          </span>
        ))}
      </div>
    );
  }
  return <span className={styles.text}>{label}</span>;
};

  return (
    <div
      className={`${styles.sidebarContainer} ${expanded ? styles.expanded : ""}`}
      style={{ backgroundColor: theme.sidebarBackgroundColor }}>
      <div
        className={`${styles.menuIcon} ${expanded ? styles.menuIconExpanded : ""}`}
        onClick={toggleSidebar}>
        <img
          src={expanded ? BackIcon : HamburgerIcon}
          alt="Menu"
          className={styles.icon}
        />
      </div>

      <div className={`${styles.menuItems} ${expanded ? styles.menuItemsExpanded : ""}`}>
        {topItems.map(item => {
          const route = getRoute(item);
          const label = getLabel(item);
          return (
            <div
              key={item.key}
              className={`${styles.menuItem} ${expanded ? styles.expandedItem : ""}`}
              onClick={() => handleItemClick(item, route)}>
              <img src={item.icon} alt={item.key} className={styles.icon} />
              { expanded && renderLabel(label)}
            </div>
          );
        })}
      </div>
      {expanded && (
        <div className={styles.panelVersion}>
          <p>Versão : {VERSION_NAME}</p>
        </div>
      )}
      <div
        className={`${styles.bottomItem} ${expanded ? styles.bottomItemExpanded : ""}`}>
        {bottomItems.map(item => {
          const route = getRoute(item);
          const label = getLabel(item);
          return (
            <div
              key={item.key}
              className={`${styles.menuItem} ${expanded ? styles.expandedItem : ""}`}
              onClick={() => handleItemClick(item, route)}>
              <img src={item.icon} alt={item.key} className={styles.icon} />
              {expanded && renderLabel(label)}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Sidebar;